import { render, staticRenderFns } from "./AddCommunityVenue.vue?vue&type=template&id=37a1d352"
import script from "./AddCommunityVenue.vue?vue&type=script&lang=js"
export * from "./AddCommunityVenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports